/**
 * Central API configuration. Nothing else in the app should read
 * REACT_APP_* variables or build backend URLs.
 *
 * REACT_APP_API_BASE_URL  Backend origin, e.g. http://localhost:8080
 *                         (no trailing slash needed; no secrets here, it is public in the bundle)
 * REACT_APP_USE_MOCKS     "true" switches the client to the in-memory mock adapter (read in client.js).
 *                         Development/test only: ignored, and stripped from the bundle, in production builds.
 */
const DEFAULT_BASE_URL = 'http://localhost:8080';

export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || DEFAULT_BASE_URL).replace(/\/+$/, '');

export const REQUEST_TIMEOUT_MS = 15000;

/**
 * Microsoft dev tunnels show an interstitial HTML warning page to non-browser requests unless this header is
 * sent (see the backend handover). It is only added for tunnel hosts: a production API does not need it, and
 * an extra custom header would force a CORS preflight on every call.
 */
export const IS_DEV_TUNNEL = /\.devtunnels\.ms$/i.test(new URL(API_BASE_URL).hostname);
